import { Image, message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful, { baseURL } from "../../restful";

interface DataType {
    name: String
    messagename: String
    roile: String
    _id: String
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const MessagesTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/messages/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [

        { sorter: true, title: 'متن پیام', dataIndex: 'text', key: 'text' },
        {
            sorter: true, title: 'زمان شروع', dataIndex: 'startAt', key: 'startAt', width: 170,
            render(val) {
                if (val) return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            sorter: true, title: 'زمان پایان', dataIndex: 'endAt', key: 'endAt', width: 170,
            render(val) {
                if (val) return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val) {
                return <Actions id={val}
                    onEdit={(id: string) => navigate('/messages-form?id=' + id)}
                    onDelete={onDeleteAction} />
            }
        },
    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/messages/paginate`, { params: {...params, ...filters} })
            .then((res) => {
                const result = res.data.result
                setItems(result.messages);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.messagesCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default MessagesTable

